import { useMutation, useQueryClient } from "@tanstack/react-query";    

import { uploadVideo } from "../../api/videos";

export const useUploadVideo = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: uploadVideo,
        onSuccess: () => {
            // Optionally, you can trigger a refetch of videos or show a success message
            queryClient.invalidateQueries({ queryKey: ["videos"] });
            console.log("Video uploaded successfully");
        },
        onError: (error) => {
            console.error("Error uploading video:", error);
        },
    });
}       

export default useUploadVideo;